// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"vS-z","inlineTitle":"wS-z","sponsoredAdsWrapper":"xS-z","marketplaceRecosWrapper":"yS-z"};